export default "__VITE_ASSET__DSs64hKD__"